import React from "react";

const Magnify = ({color}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M12.4999 10.9996H11.7099L11.4299 10.7296C12.6299 9.32965 13.2499 7.41965 12.9099 5.38965C12.4399 2.60965 10.1199 0.389649 7.3199 0.049649C3.0899 -0.470351 -0.460103 3.08965 0.0498967 7.31965C0.389897 10.1196 2.6099 12.4396 5.3899 12.9096C7.4199 13.2496 9.3299 12.6296 10.7299 11.4296L10.9999 11.7096V12.4996L15.2599 16.7496C15.6699 17.1596 16.3299 17.1596 16.7399 16.7496L16.7499 16.7396C17.1599 16.3296 17.1599 15.6696 16.7499 15.2596L12.4999 10.9996ZM6.4999 10.9996C4.0099 10.9996 1.9999 8.98965 1.9999 6.49965C1.9999 4.00965 4.0099 1.99965 6.4999 1.99965C8.9899 1.99965 10.9999 4.00965 10.9999 6.49965C10.9999 8.98965 8.9899 10.9996 6.4999 10.9996ZM6.4999 3.99965C6.2199 3.99965 5.9999 4.21965 5.9999 4.49965V5.99965H4.4999C4.2199 5.99965 3.9999 6.21965 3.9999 6.49965C3.9999 6.77965 4.2199 6.99965 4.4999 6.99965H5.9999V8.49965C5.9999 8.77965 6.2199 8.99965 6.4999 8.99965C6.7799 8.99965 6.9999 8.77965 6.9999 8.49965V6.99965H8.4999C8.7799 6.99965 8.9999 6.77965 8.9999 6.49965C8.9999 6.21965 8.7799 5.99965 8.4999 5.99965H6.9999V4.49965C6.9999 4.21965 6.7799 3.99965 6.4999 3.99965Z"
        fill={color}
        fillOpacity={1}
      />
    </svg>
  );
};

export default Magnify;
